// In-memory Map that associates structure IDs with their most recent checkout config IDs.
// We're avoiding local storage because we anticipate sales reps taking multiple customers
// through the flow on their same machine, and so want each tab/refresh to get a new config.
// This ensures that each browser tab maintains its own isolated configuration state
// without persisting data that could interfere with other customer sessions.
export const structureIdToLastConfigId = new Map<string, string>();
